<template>
  <div :class="loadingClasses">
    <i v-if="loading" class="spinner fas fa-spinner fa-spin fa-2x fa-fw"></i>
    <p v-if="error && !loading" class="no-data-warning">{{ message }}</p>
    <slot v-if="!error && !loading"/>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
    },
    error: {
      type: Boolean,
    },
    message: {
      type: String,
      default: 'No Data',
    },
  },
  computed: {
    activeView() {
      return this.$store.state.main.activeView;
    },
    loadingClasses() {
      return {
        'loading-insights': this.activeView === 'Insights' && this.loading,
        'loading-explorer': this.activeView === 'Explorer' && this.loading,
      };
    },
  },
};
</script>

<style>
  .loading-insights {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
  }

  .loading-explorer {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .spinner {
    color: #26c7c8;
  }
</style>
